<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_5079_13592)">
      <path d="M6.00195 5.5C6.00195 5.89782 5.84392 6.27936 5.56261 6.56066C5.28131 6.84196 4.89978 7 4.50195 7C4.10413 7 3.7226 6.84196 3.44129 6.56066C3.15999 6.27936 3.00195 5.89782 3.00195 5.5C3.00195 5.10218 3.15999 4.72064 3.44129 4.43934C3.7226 4.15804 4.10413 4 4.50195 4C4.89978 4 5.28131 4.15804 5.56261 4.43934C5.84392 4.72064 6.00195 5.10218 6.00195 5.5Z" :fill="color"/>
      <path d="M2.00195 1C1.47152 1 0.962812 1.21071 0.58774 1.58579C0.212667 1.96086 0.00195313 2.46957 0.00195312 3V13C0.00195313 13.5304 0.212667 14.0391 0.58774 14.4142C0.962812 14.7893 1.47152 15 2.00195 15H14.002C14.5324 15 15.0411 14.7893 15.4162 14.4142C15.7912 14.0391 16.002 13.5304 16.002 13V3C16.002 2.46957 15.7912 1.96086 15.4162 1.58579C15.0411 1.21071 14.5324 1 14.002 1H2.00195ZM14.002 2C14.2672 2 14.5215 2.10536 14.7091 2.29289C14.8966 2.48043 15.002 2.73478 15.002 3V9.5L11.225 7.553C11.1312 7.50602 11.025 7.48973 10.9215 7.50642C10.8179 7.52311 10.7222 7.57194 10.648 7.646L6.93795 11.356L4.27795 9.584C4.18191 9.52006 4.06672 9.4913 3.95189 9.5026C3.83707 9.5139 3.72969 9.56456 3.64795 9.646L1.00195 12V3C1.00195 2.73478 1.10731 2.48043 1.29485 2.29289C1.48238 2.10536 1.73674 2 2.00195 2H14.002Z" :fill="color"/>
    </g>
    <defs>
      <clipPath id="clip0_5079_13592">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
